import PropTypes from "prop-types";

import Container from "react-bootstrap/Container";

import iconsBack from "../../assets/svg/icons-back.svg";

import iconsLinkedIn from "../../assets/svg/icons-linkedin.svg";

import ReturnBackComponent from "../../utils/ReturnBackComponent";

import { useTranslation } from "react-i18next";

import {
  HOME,
  CLIENT_ID_LINKEDIN_API,
  CLIENT_SECRET,
  REDIRECT_URI,
  SCOPE,
  REGISTER,
  USER_EMAIL,
  PASSWORD,
} from "../../constants/stringConstants";

import ThreeLevelMessage from "../../utils/ThreeLevelMessage";

import Row from "react-bootstrap/Row";

import Col from "react-bootstrap/Col";

import Footer from "../FooterComponents/Footer";

import FieldsInForm from "../../utils/FieldsInForm";

import emailRegex from "email-regex";

import InputGroup from "react-bootstrap/InputGroup";

import Form from "react-bootstrap/Form";

import { connect } from "react-redux";

import {
  logInUser,
  authorizeLinkedIn,
  userLoggingIsLoadedWithError,
} from "../../actions/userActions";

import { bindActionCreators } from "redux";

import { LinkedIn } from "react-linkedin-login-oauth2";

import AlertMessage from "../../utils/AlertMessage";

import { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import { MAIN_WEBSITE_URL } from "../../constants/urls";

import CustomModal from "../../utils/CustomModal";

import Loader from "../../utils/Loader";

const LogInContainer = ({
  logInUser,
  authorizeLinkedIn,
  userLoggingErrorMessage,
  userLoggingIsLoadedWithError,
  loggedIn,
  userLoggingIsLoading,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [failureMessage, setFailureMessage] = useState("");

  useEffect(() => {
    if (userLoggingErrorMessage) {
      setFailureMessage(userLoggingErrorMessage);
      userLoggingIsLoadedWithError(false, "");
    }

    if (loggedIn) {
      history.push(HOME);
    }
  }, [
    userLoggingErrorMessage,
    setFailureMessage,
    userLoggingIsLoadedWithError,
    loggedIn,
    history,
  ]);

  const args = {
    findFormErrors: (form) => {
      const { USER_EMAIL, PASSWORD } = form;
      const newErrors = {};

      if (!USER_EMAIL || USER_EMAIL === "")
        newErrors.USER_EMAIL = t("emailIsMandatory");
      else if (USER_EMAIL.length > 50)
        newErrors.USER_EMAIL = t("emailCantBeLongerThan50");
      else if (!emailRegex({ exact: true }).test(USER_EMAIL))
        newErrors.USER_EMAIL = t("emailHasntBeFormattedCorrectly");
      // else if (
      //   USER_EMAIL.includes("@gmail") ||
      //   USER_EMAIL.includes("@live") ||
      //   USER_EMAIL.includes("@hotmail") ||
      //   USER_EMAIL.includes("@outlook") ||
      //   USER_EMAIL.includes("@protonmail") ||
      //   USER_EMAIL.includes("@pm.me") ||
      //   USER_EMAIL.includes("@aol") ||
      //   USER_EMAIL.includes("@zolo") ||
      //   USER_EMAIL.includes("@icloud") ||
      //   USER_EMAIL.includes("@me") ||
      //   USER_EMAIL.includes("@mac") ||
      //   USER_EMAIL.includes("@yahoo") ||
      //   USER_EMAIL.includes("@gmx") ||
      //   USER_EMAIL.includes("@web.de") ||
      //   USER_EMAIL.includes("@ionos") ||
      //   USER_EMAIL.includes("@freenet")
      // ) {
      //   newErrors.USER_EMAIL = t("emailHasToBeBusinessEmail");
      // }

      if (!PASSWORD || PASSWORD === "")
        newErrors.PASSWORD = t("passwordIsMandatoryField");
      else if (PASSWORD.length > 255)
        newErrors.PASSWORD = t("passwordCantBeLongerThan255");
      else if (PASSWORD.length < 6)
        newErrors.PASSWORD = t("passwordCantBeShorterThan6");

      return newErrors;
    },
    fields: [
      {
        name: USER_EMAIL,
        type: "text",
        className: "register-login-text-field",
        required: true,
        classnameofgroup: "register-login-text-field-group",
        label: t("workEmail"),
        placeholder: t("workEmail"),
      },
      {
        name: PASSWORD,
        type: "password",
        className: "register-login-text-field",
        required: true,
        classnameofgroup: "register-login-text-field-group",
        label: t("yourPassword"),
        placeholder: t("yourPassword"),
      },
      {
        name: "-",
        type: "submit",
        className: "register-login-button",
        required: false,
        classnameofgroup: "",
        label: t("logIn"),
        as: "input",
      },
    ],
    onSubmit: (values) => {
      logInUser(values.USER_EMAIL, values.PASSWORD);
    },
    classNameReactFormal: "register-login-react-formal",
    classNameForm: "register-login-react-form",
  };

  return (
    <Container expand="lg" className="home-page-container">
      <ReturnBackComponent
        text={t("mainWebSite")}
        image={iconsBack}
        url={MAIN_WEBSITE_URL}
      />
      <Container expand="lg" className="register-log-in-container">
        <ThreeLevelMessage
          textOfLevel1={t("welcomeBack")}
          textOfLevel2={t("joinHundredsOfYourCollegues")}
          classNameOfContainer="register-log-in-two-level-message"
          classNameOfLevel1="register-log-in-first-level-message fs-21"
          classNameOfLevel2="register-log-in-second-level-message fs-12"
        />
      </Container>
      <Container expand="lg" className="register-log-in-fields-container">
        <Row className="register-log-in-fields-row">
          <Col className="register-log-in-fields-col-left">
            <FieldsInForm
              fields={args.fields}
              findFormErrors={args.findFormErrors}
              classNameForm={args.classNameForm}
              onSubmit={args.onSubmit}
            />
            <span className="first-below-register-explanation fs-14 helvetica first-explanation">
              {t("dontHaveAnAccountYet") + " "}
              <a
                href={REGISTER}
                className="register-terms-of-use-privacy cursor-pointer"
              >
                {t("createOneForFree")}
              </a>
            </span>
          </Col>
          <Col className="register-log-in-fields-col-right">
            <span className="register-log-in-second-col-text fs-16 helvetica">
              {t("orUtiliseOneOfYourExistingAccountsToLogIn")}
            </span>
            <Form
              className="mr-auto register-log-in-other-way-group"
              id="linked-in-form"
            >
              <LinkedIn
                clientId={CLIENT_ID_LINKEDIN_API}
                secret={CLIENT_SECRET}
                scope={SCOPE}
                onSuccess={(data) => {
                  authorizeLinkedIn(data.code, "logIn");
                }}
                onFailure={(err) => console.log(err)}
                redirectUri={REDIRECT_URI}
                renderElement={({ onClick }) => (
                  <InputGroup
                    onClick={() => onClick()}
                    className="register-log-in-other-way cursor-pointer"
                  >
                    <InputGroup.Prepend>
                      <InputGroup.Text id="linked-in-register-log-in fs-14">
                        <img
                          src={iconsLinkedIn}
                          width="25"
                          height="25"
                          className="linked-in-icon"
                          alt="LinkedIn"
                        />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <InputGroup.Text style={{ paddingLeft: "5px" }}>
                      {t("logInWithLinkedIn")}
                    </InputGroup.Text>
                  </InputGroup>
                )}
              />
            </Form>
          </Col>
        </Row>
      </Container>
      {failureMessage ? (
        <AlertMessage
          variant="danger"
          onClose={() => setFailureMessage("")}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      ) : (
        <div className="display-none" />
      )}
      <CustomModal
        classNameOfModal="reghub-loading-modal"
        isShown={userLoggingIsLoading}
        content={<Loader />}
        titleOfModal={t("loading")}
        isCentered={true}
        isBackdrop="static"
      />
      <Footer />
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    userLoggingErrorMessage: state.userReducer.userLoggingErrorMessage,
    loggedIn: state.userReducer.loggedIn,
    userLoggingIsLoading: state.userReducer.userLoggingIsLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logInUser: bindActionCreators(logInUser, dispatch),
    authorizeLinkedIn: bindActionCreators(authorizeLinkedIn, dispatch),
    userLoggingIsLoadedWithError: bindActionCreators(
      userLoggingIsLoadedWithError,
      dispatch
    ),
  };
};

LogInContainer.propTypes = {
  logInUser: PropTypes.func.isRequired,
  authorizeLinkedIn: PropTypes.func.isRequired,
  userLoggingErrorMessage: PropTypes.string.isRequired,
  userLoggingIsLoadedWithError: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  userLoggingIsLoading: PropTypes.bool.isRequired,
};

LogInContainer.defaultProps = {
  logInUser: () => {},
  authorizeLinkedIn: () => {},
  userLoggingErrorMessage: "",
  userLoggingIsLoadedWithError: () => {},
  loggedIn: false,
  userLoggingIsLoading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(LogInContainer);
